module.exports = __webpack_public_path__ + "img/pdfImg.32e256ca.png";